import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';

/**
 * Ends an asynchronous datapoint taking into account rendering time
 * @param dataPoint The datapoint to end
 */
export function endAsyncDatapoint(dataPoint: PerformanceDatapoint) {
    // add a checkmark to datapoint before requestAnimationFrame is called, so that we can measure the time needed subtracting the animation time
    dataPoint.addCheckmark('actionComplete');

    // Run this in requestAnimationFrame to provide a chance for react to rerender the view,
    // then we log the datapoint which will contain the rerender time.
    // requestAnimationFrame won't get called if the page is not visible. So let's make sure the page is
    // currently visible. If not, then let's end the action here as there is no render time
    if (window.document && window.document.visibilityState == 'visible') {
        window.requestAnimationFrame(function endActionWithTime() {
            dataPoint.end();
        });
    } else {
        dataPoint.end(undefined, DatapointStatus.BackgroundSuccess);
    }
}
